import { render, staticRenderFns } from "./UserAbout.vue?vue&type=template&id=5d9bd0bd&scoped=true&"
import script from "./UserAbout.vue?vue&type=script&lang=js&"
export * from "./UserAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bd0bd",
  null
  
)

export default component.exports